import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CloseIcon from "@mui/icons-material/Close";
import API_URL from "./Apiurl";

import "./styles/styles.css";

export default class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldpassword: "",
      newpassword: "",
      confirmpassword: "",
      OldshowPassword: false,
      newshowpassword: false,
      confirmshowpassword: false,
      btndisabled: false,
      submitbtn: "Change Password",
      erropen: false,
      errormessage: "",
      errortype: "error",
      redirect: false,
    };
  }
  componentWillMount() {
	let strname="Change Password";   
	 this.props.parentsCallback(
           strname
        );	
  }
  myChangeHandler = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleErrorclose = () => {
    this.setState({ erropen: false });
  };

  handleClickOldShowPassword = () => {
    this.setState({ OldshowPassword: !this.state.OldshowPassword });
  };

  handleClickNewShowPassword = () => {
    this.setState({ newshowpassword: !this.state.newshowpassword });
  };

  handleClickConfirmpassowrd = () => {
    this.setState({ confirmshowpassword: !this.state.confirmshowpassword });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { oldpassword, newpassword, confirmpassword } = this.state;

    if (!oldpassword.trim()) {
      return this.setState({
        errormessage: "Please enter old password",
        erropen: true,
        errortype: "error",
      });
    }
    if (!newpassword.trim()) {
      return this.setState({
        errormessage: "Please enter new password",
        erropen: true,
        errortype: "error",
      });
    }
    if (!confirmpassword.trim()) {
      return this.setState({
        errormessage: "Please enter confirm password",
        erropen: true,
        errortype: "error",
      });
    }
    if (newpassword !== confirmpassword) {
      return this.setState({
        errormessage: "New password and confirm password do not match",
        erropen: true,
        errortype: "error",
      });
    }
    if (oldpassword === newpassword) {
      return this.setState({
        errormessage: "New password must be different from old password",
        erropen: true,
        errortype: "error",
      });
    }

    this.setState({ btndisabled: true, submitbtn: "Processing...", erropen: false });

    const formData = new FormData();
    formData.append("action", "changepassword");
    formData.append("us_id", localStorage.getItem("VRuserid"));
    formData.append("oldpassword", oldpassword);
    formData.append("newpassword", newpassword);
    formData.append("retypepassword", confirmpassword);

    axios
  .post(`${API_URL}ajaxuser.php`, formData)
      .then((res) => {
         const msg = Number(res.data);
        if (msg === 1) {
          this.setState({
            submitbtn: "Change Password",
            btndisabled: false,
            errormessage: "Password updated successfully.",
            erropen: true,
            errortype: "success",
            oldpassword: "",
            newpassword: "",
            confirmpassword: "",
	
          });
          localStorage.clear();
          window.scrollTo({ top: 0 });
        } else if (msg === -1) {
          this.setState({
            submitbtn: "Change Password",
            btndisabled: false,
            errormessage: "Old password is incorrect.",
            erropen: true,
            errortype: "error",
          });
        } else {
          this.setState({
            submitbtn: "Change Password",
            btndisabled: false,
            errormessage: "Unexpected error occurred.",
            erropen: true,
            errortype: "error",
          });
        }
      });
  };

  render() {
   

    return (
       <React.Fragment>
	  
       

          

          <div className="changepassword">
		     <Collapse in={this.state.erropen}>
            <Alert
              severity={this.state.errortype}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={this.handleErrorclose}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {this.state.errormessage}
            </Alert>
          </Collapse>
            <ul>
              <li>
                <p>
                  Old Password <span className="changevalidation">*</span>
                </p>
                <TextField
                  fullWidth
                 className="inputcntlparent" size="small"
                  value={this.state.oldpassword}
                  name="oldpassword"
                  onChange={this.myChangeHandler}
                  type={this.state.OldshowPassword ? "text" : "password"}
                  slotProps={{
					      input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={this.handleClickOldShowPassword}
                          onMouseDown={this.handleMouseDownPassword} className="inputicons"
                        >
                          {this.state.OldshowPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
						  }
                  }}
                />
              </li>

              <li>
                <p>
                  New Password <span className="changevalidation">*</span>
                </p>
                <TextField
                  fullWidth
                  className="inputcntlparent" size="small"
                  value={this.state.newpassword}
                  name="newpassword"
                  onChange={this.myChangeHandler}
                  type={this.state.newshowpassword ? "text" : "password"}
                 slotProps={{
					      input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={this.handleClickNewShowPassword}
                          onMouseDown={this.handleMouseDownPassword} className="inputicons"
                        >
                          {this.state.newshowpassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
						  }
                  }}
                />
              </li>

              <li>
                <p>
                  Confirm Password <span className="changevalidation">*</span>
                </p>
                <TextField
                  fullWidth
                  className="inputcntlparent" size="small"
                  value={this.state.confirmpassword}
                  name="confirmpassword"
                  onChange={this.myChangeHandler}
                  type={this.state.confirmshowpassword ? "text" : "password"}
                 slotProps={{
					      input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={this.handleClickConfirmpassowrd}
                          onMouseDown={this.handleMouseDownPassword} className="inputicons"
                        >
                          {this.state.confirmshowpassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
						  }
                  }}
                />
              </li>
			  <li>
			  <p className="changealigncentr">
            <Button
              variant="contained"
              className="frmPrimarybtn"
              disabled={this.state.btndisabled}
              onClick={this.handleSubmit}
            >
              {this.state.submitbtn}
            </Button>
          </p>
			  </li>
            </ul>
          </div>

          
        </React.Fragment>
    );
  }
}